/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Termsandconditions2Inputs */

const en_termsandconditions2 = /** @type {(inputs: Termsandconditions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions`)
};

const de_termsandconditions2 = /** @type {(inputs: Termsandconditions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschäftsbedingungen`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions" |
*
* @param {Termsandconditions2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const termsandconditions2 = /** @type {((inputs?: Termsandconditions2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Termsandconditions2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_termsandconditions2(inputs)
	return de_termsandconditions2(inputs)
});
export { termsandconditions2 as "termsAndConditions" }